const config = {
  defaultPath: '/',
};

export default config;

export const drawerWidth = 260;
export const NAV_ROW_HEIGHT = 60;
export const JOB_BAR_HEIGHT = 50;
